<template>
    <div class="detail-header">
        <div class="row gap-5">
            <div class="col-xs-12 col-sm-8 col-md-9">
                <h2>{{room.name}} <span class="star-rate rated-40"></span></h2>
                <p class="mb-0">{{room.address}}, 25194 {{room.city}} - <a target="_blank" rel="noopener noreferrer"
                                                                           :href="'https://www.google.es/maps/place/VOLA/@'+this.room.lat+','+this.room.lng+',17z/data=!3m1!4b1!4m5!3m4!1s0x12a6e01275f493b3:0x98a69b6f97d357c5!8m2!3d41.6052836!4d0.6120879'"
                                                                           class="font13 anchor" data-toggle="tab">
                    <font-awesome-icon style="margin-right: 0.5em;" icon="map-marker-alt"/>
                    Ver en mapa</a></p>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "headTitle",
        data: function () {
            return {
                room: [],
            }
        },
        methods: {
            async getRoom(lat, lng) {
                let url = "https://roomapi.vola.cat/clients/getroom/" + this.$route.params.roomid;
                const rooms = await axios.get(url);
                this.room = rooms.data.meetingRoom;
                this.isLoading = false;
            },
        },
        mounted() {
            this.getRoom();
        }
    }
</script>

<style scoped>
    .star-rate {
        color: #8ac6c4 !important;
    }
</style>